
























import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

import {VAutocomplete, VSelect, VLayout, VTextField} from 'vuetify/lib'
import {ValidationProvider} from 'vee-validate'
import Countries, {Country} from '@/lib/kepler/countries'

@Component({
  components: {VSelect, ValidationProvider, VAutocomplete, VLayout, VTextField},
  name: 'CountriesFieldWithValidation',
})
export default class CountriesFieldWithValidation extends Vue {

  @Prop({
    type: [String, Object],
    default: () => '',
  }) public readonly rules!: string | object

  @Prop({
    type: [String, Object],
    default: () => null,
  }) public readonly value!: string | null

  @Prop({
    type: Array,
    default: () => [],
  }) public items!: Country[]

  public innerValue: Country | null = null

  public get countries(): Country[] {
    return this.items.length ? this.items : Countries
  }

  @Watch('innerValue')
  public onInnerValueChange(newVal: Country) {
    if (newVal) {
      this.$emit('input', newVal.code)
    }
  }

  @Watch('value')
  public onValueChange(newVal: string) {
    this.updateVal(newVal)
  }

  public updateVal(val: string | null) {
    if (val) {
      const v = this.countries.find((i) => {
        return i.code.toLowerCase() === val.toLowerCase()
      })
      if (v) {
        this.innerValue = v
      }
    }
  }

  public created() {
    const r = this.rules
    const defaultValue = (() => {
      if (r && typeof r === 'string') {
        return r.split('|').find((rule: string) => rule.toLowerCase().startsWith('default'))?.split(':')[1]
      } else if (r && typeof r === 'object' && r.hasOwnProperty('default')) {
        return (r as any)[`default`] as string | undefined
      }
    })()

    this.updateVal(this.value ? this.value : (defaultValue?.toUpperCase() || null))

    // TODO: reverse geocoding from position
  }
}
